import { render, staticRenderFns } from "./department_point.vue?vue&type=template&id=dcd61aae&"
import script from "./department_point.vue?vue&type=script&lang=js&"
export * from "./department_point.vue?vue&type=script&lang=js&"
import style0 from "./department_point.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports